<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="colli_sscc" [ttModel]="edit.colli_sscc" ttReadonly></tt-input>

            <tt-tabs [(ttSelectedId)]="selectedBgConsignmentColliDetail">
                <tt-tab ttId="BASIS" ttLabel="bg_consignmentcollidetail_basis"></tt-tab>
                <tt-tab ttId="CONTENT" ttLabel="bg_consignmentcollidetail_content"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgConsignmentColliDetail !== 'BASIS'">
                <ng-container *ngTemplateOutlet="calculations"></ng-container>
            </div>

            <tt-button-save ttText="save" (ttClick)="saveItemsChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>

        <tt-list [hidden]="selectedBgConsignmentColliDetail !== 'CONTENT'" [ttData]="itemsListDetails" [ttGoto]="false"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input ttLabel="colli_sscc" [ttModel]="edit.colli_sscc" ttReadonly></tt-input>
            <ng-container *ngTemplateOutlet="calculations"></ng-container>
            <tt-button-save ttText="save" (ttClick)="saveGridChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #calculations>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="description" [(ttModel)]="edit.description"></tt-input>
        <tt-input-number ttLabel="volume_m3" [(ttModel)]="edit.volume" ttTextAlign="right" ttFormatNumber ttDecimals="6"></tt-input-number>
        <tt-input-number ttLabel="weight_kg" [(ttModel)]="edit.weight" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="length_cm" [(ttModel)]="edit.length" (ttModelChange)="onChanged($event, 'length')" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="width_cm" [(ttModel)]="edit.width" (ttModelChange)="onChanged($event, 'width')" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input-number ttLabel="height_cm" [(ttModel)]="edit.height" (ttModelChange)="onChanged($event, 'height')" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input *ngIf="edit.case_keyno === '0'" ttLabel="case_keyno" [ttModel]="edit.case_keyno" ttReadonly></tt-input>
        <tt-input *ngIf="edit.case_keyno !== '0'" ttLabel="case_keyno" [ttModel]="edit.case_keyno" [ttButtons]="caseButtons" ttReadonly></tt-input>
    </ng-container>
</ng-template>
